const partnerCode = {
  derTourPromotion: 'GN32Vg3bVOJp9TYBGtHLsnM8x4A8ZYin',
  tui: 'vFgWJN7hcMAMnOnkwSU1111q9QkIdsyz',
};
export default partnerCode;
